import React, { useState } from "react";
import { Alert } from "components/base/Toast";
import { FiCopy, FiCheck } from "react-icons/fi";
import { InlineSpinner } from "components/base/Spinner";

// 结果查看器组件
const ResultViewer = ({ result, loading, error }) => {
  const [copied, setCopied] = useState(false);

  // 复制结果到剪贴板
  const copyResultToClipboard = () => {
    if (result) {
      navigator.clipboard.writeText(JSON.stringify(result, null, 2)).then(
        function () {
          setCopied(true);
          // 3秒后重置图标
          setTimeout(() => {
            setCopied(false);
          }, 3000);
        },
        function (err) {
          Alert("error", "无法复制: " + err);
        },
      );
    }
  };
  return (
    <>
      {/* 加载提示 */}
      {loading && (
        <div className="flex justify-center my-4">
          <InlineSpinner size={24} />
        </div>
      )}

      {/* 错误提示 */}
      {error && (
        <div className="bg-red-50 p-4 rounded-lg text-red-700 mb-4">
          <p>{error.message || "未知错误"}</p>
          {error.graphQLErrors?.length > 0 && (
            <ul className="list-disc pl-5 mt-2">
              {error.graphQLErrors.map((err, index) => (
                <li key={index}>{err.message}</li>
              ))}
            </ul>
          )}
        </div>
      )}

      {/* 查询结果 */}
      {result && (
        <div className="mt-4">
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-medium">查询结果</h3>
            <button
              className="p-2 bg-gray-100 hover:bg-gray-200 rounded transition-colors flex items-center justify-center"
              onClick={copyResultToClipboard}
              title="复制JSON"
            >
              {copied ? (
                <FiCheck className="text-green-600" />
              ) : (
                <FiCopy className="text-gray-600" />
              )}
            </button>
          </div>
          <div className="border rounded-lg p-4 bg-gray-50 overflow-x-auto">
            <div className="font-mono text-sm max-h-[calc(100vh-400px)] overflow-y-auto whitespace-pre">
              {JSON.stringify(result, null, 2)}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ResultViewer;
